"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreSonarObjectsWatchers = exports.coreSonarObjectsReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const _idMap_1 = require("./_idMap/index.js");
const optimistic_1 = require("./optimistic/index.js");
const applications_1 = require("./applications/index.js");
const bulk_1 = require("./bulk/index.js");
const context_1 = require("./context/index.js");
const initiatives_1 = require("./initiatives/index.js");
const pageLayouts_1 = require("./pageLayouts/index.js");
const profiles_1 = require("./profiles/index.js");
const salesforce_1 = require("./salesforce/index.js");
const search_1 = require("./search/index.js");
const stakeholders_1 = require("./stakeholders/index.js");
const users_1 = require("./users/index.js");
exports.coreSonarObjectsReducers = (0, redux_1.combineReducers)({
    applications: applications_1.coreSonarObjectsApplicationsReducers,
    bulk: bulk_1.coreSonarObjectsBulkReducers,
    byIdMap: _idMap_1.coreSonarObjectsIdMapReducers,
    context: context_1.coreSonarObjectsContextReducers,
    initiatives: initiatives_1.coreSonarObjectsInitiativesReducers,
    optimistic: optimistic_1.coreSonarObjectsOptimisticReducers,
    pageLayouts: pageLayouts_1.coreSonarObjectsPageLayoutsReducers,
    profiles: profiles_1.coreSonarObjectsProfilesReducers,
    salesforce: salesforce_1.coreSonarObjectsSalesforceUpdateableReducers,
    search: search_1.coreSonarObjectsSearchReducers,
    stakeholders: stakeholders_1.coreSonarObjectsStakeholdersReducers,
    users: users_1.coreSonarObjectsUsersReducers
});
exports.coreSonarObjectsWatchers = (0, xuder_1.combineAllWatchers)([
    applications_1.coreSonarObjectsApplicationsWatchers,
    bulk_1.coreSonarObjectsBulkWatchers,
    context_1.coreSonarObjectsContextWatchers,
    initiatives_1.coreSonarObjectsInitiativesWatchers,
    pageLayouts_1.coreSonarObjectsPageLayoutsWatchers,
    profiles_1.coreSonarObjectsProfilesWatchers,
    salesforce_1.coreSonarObjectsSalesforceUpdateableWatchers,
    search_1.coreSonarObjectsSearchWatchers,
    stakeholders_1.coreSonarObjectsStakeholdersWatchers,
    users_1.coreSonarObjectsUsersWatchers
]);
//# sourceMappingURL=index.js.map